import en from './en';
import vi from './vi';
import zh from './zh';
import ja from './ja';
import ko from './ko';
import ru from './ru';

const locales = { en, vi, zh, ja, ko, ru };

export default locales;